import { SmartTagSystemOperations } from 'tag/ts/smart_tag/operations/SmartTagSystemOperations';
import { SmartTagTagOperations } from 'tag/ts/smart_tag/operations/SmartTagTagOperations';
import { ISmartTagOperationsDependencies } from 'tag/ts/smart_tag/operations/types/SmartTagOperationsTypes';
import { TTagRemoveData } from 'tag/ts/smart_tag/types/api/TTagRemoveData';
import { TTagResetData } from 'tag/ts/smart_tag/types/api/TTagResetData';
import { ITag } from 'tag/ts/tag/interfaces/ITag';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Coordinator for SmartTag operations using composition pattern
 *
 * This coordinator delegates operations to specialized classes to reduce cognitive
 * complexity while maintaining a clean public API. Uses dependency injection to
 * avoid tight coupling with SmartTag internals, improving testability and maintainability.
 *
 * The composition pattern allows for focused, single-responsibility classes while
 * preserving the original SmartTag interface for backward compatibility.
 */
export class SmartTagOperations {
	#tagOps: SmartTagTagOperations;
	#systemOps: SmartTagSystemOperations;

	constructor( deps: ISmartTagOperationsDependencies ) {
		this.#tagOps = new SmartTagTagOperations( deps );
		this.#systemOps = new SmartTagSystemOperations( deps );
	}

	removeTag = ( tag: ITag ): Promise<TTagRemoveData> => this.#tagOps.removeTag( tag );
	resetTags = (): Promise<TTagResetData> => this.#tagOps.resetTags();
	initializeConnectionMonitor = (): void => this.#systemOps.initializeConnectionMonitor();
	ensureAviaErrorHandler = (): void => this.#systemOps.ensureAviaErrorHandler();
	handleAutoplayDetection = (): void => this.#systemOps.handleAutoplayDetection();
}